import { getID } from "src/libs/utilities"

const horizontal_accordeon = (): any[] => {
    return [ 
        {
            id: getID("horizontal_accordeon"),
            title: "Gradient",
            "cardColors": ["#ea848e", "#112c99"],
            "isOrder": false,    
            "isNoBackground": false, 
            "label_size": 22,
            "card_label": {
            "letterSpacing": "1px",
            "textTransform": "upperCase", 
            "alignItems": "flex-end"
            },
            "card": { },
            "card_cover": { },
            "card_icon": { }
        }, 
        {
            id: getID("horizontal_accordeon"),
            title: "Minimal",
            isNoBackground: true, 
            "isOrder": 0,
            "label_size": 22,
            "card_label": {
                "letterSpacing": "4px",
                "textTransform": "upperCase", 
                "alignItems": "flex-end"
            },
            "card": { },
            "card_cover": { },
            "card_icon": { }
        }, 
        {
            id: getID("horizontal_accordeon"),
            title: "Modern light",  
            isNoBackground: true, 
            "cover_width": 50,  
            "icon_size" :19,
            "isOrder": 0,
            "label_size": 45,
            "card_label": {
                "letterSpacing": "4px",
                "textTransform": "upperCase",
                "fontWeight": 100,
                "alignItems": "flex-end"
            },
            "card": {
                "margin": "0 8px",
                "borderRadius": "0px",
                "borderRight": "1px dotted var(--force-contrast-opacity-color)",
                "backgroundColor": "transparent"
            },
            "card_cover": { },
            "card_icon": {
                "display": "none"
            } 
        }, 
        {
            id: getID("horizontal_accordeon"),
            title: "Red gold",  
            "isOrder": 0,    
            "isNoBackground": false, 
            "label_size": 62,
            "cardColors": ["#9d0000", "#ebb038"],
            "card_label": {
                "letterSpacing": "1px",
                "textTransform": "upperCase", 
                "alignItems": "flex-end",
                "fontWeight": 700
            },
            "card": { },
            "card_cover": { 
                "borderRadius": 35
            },
            "card_icon": { }
        }, 
        {
            id: getID("horizontal_accordeon"),
            title: "Hotdogs",  
            "isOrder": 0,    
            "isNoBackground": 0, 
            "label_size": 24,
            "cardColors": ["#9d0000", "#ebb038"],
            "card_label": {
                "letterSpacing": "1px",
                "textTransform": "upperCase", 
                "alignItems": "flex-end",
                "fontWeight": 500
            },
            "card": {
                "outline": "1px solid var(--force-plain-color)",
                "outlineOffset": "-5px",
                "marginLeft": "8px",
                "marginRight": "8px",
                "borderRadius": "75px"
            },
            "card_cover": { 
                "borderRadius": 35
            },
            "card_icon": { }
        }, 
        {
            id: getID("horizontal_accordeon"),
            title: "Jeans",  
            "isOrder": 0,    
            "isNoBackground": 0, 
            "label_size": 24,
            "icon_size": 20,
            "cardColors": ["#362879", "#8478bb"],
            "card_label": {
            "letterSpacing": "1px",
            "textTransform": "upperCase", 
            "alignItems": "flex-end",
            "fontWeight": 500
            },
            "card": {
            "outline": "3px dashed var(--force-plain-color)",
            "outlineOffset": "-7px",
            "marginLeft": "8px",
            "marginRight": "8px",
            "borderRadius": "75px"
            },
            "card_cover": { 
            "borderRadius": 35
            },
            "card_icon": {
            "backgroundColor": "#0ecda4",
            "padding": "15px",
            "width": "50px",
            "height": "50px",
            "marginBottom": "25px",
            "borderRadius": "50px",
            "color": "#FFFFFF"
            }
        }, 
        {
            id: getID("horizontal_accordeon"),
            title: "Folders",  
            "cover_width": 50,
            "isOrder": 0,    
            "isNoBackground": 0, 
            "label_size": 18,
            "icon_size": 20, 
            "cardColors": ["#404043", "#787884"],
            "card_label": {
                "letterSpacing": "8px",
                "textTransform": "upperCase", 
                "alignItems": "flex-end",
                "fontWeight": 500
            },
            "card": { },
            "card_cover": { 
                "borderRadius": 35
            },
            "card_icon": { } 
        }, 
        {
            id: getID("horizontal_accordeon"),
            title: "Light folders",  
            "cover_width": 40,
            "isOrder": 0,    
            "isNoBackground": 1, 
            "label_size": 14,
            "icon_size": 17,
            "card_label": {
            "letterSpacing": "4px",
            "textTransform": "upperCase", 
            "alignItems": "flex-end",
            "fontWeight": 500
            },
            "card": { "borderRight": "1px solid var(--force-contrast-secondary-opacity-color)" },
            "card_cover": { },
            "card_icon": { }
        },
        {
            id: getID("horizontal_accordeon"),
            title: "Fat",  
            "cover_width": 120,
            "isOrder": 0,    
            "isNoBackground": 0, 
            "label_size": 40,
            "icon_size": 40,
            "card_label": {
            "letterSpacing": "4px",
            "textTransform": "upperCase", 
            "alignItems": "flex-start",
            "fontWeight": 900
            },
            "card": { "borderRight": "1px solid var(--force-contrast-secondary-opacity-color)" },
            "card_cover": { },
            "card_icon": { }
        },
        {
            id: getID("horizontal_accordeon"),
            title: "Bestsellers",  
            "cover_width": 75,
            "isOrder": 0,    
            "isNoBackground": 0, 
            "label_size": 30,
            "icon_size": 30,
            "cardColors--": ["#b91010", "#b91010"],
            "card_label": {
            "letterSpacing": "4px",
            "textTransform": "upperCase", 
            "alignItems": "flex-end",
            "fontWeight": 100
            },
            "card": {
            "borderRight": "1px solid var(--force-plain-color)",
            "background": "linear-gradient(to bottom, rgba(185,16,16,1) 0%,rgba(112,13,10,1) 100%)"
            },
            "card_cover": { "color": "#FFFFFF" },
            "card_icon": { "color": "#FFFFFF" }
        },
        {
            id: getID("horizontal_accordeon"),
            title: "Collected works",  
            "cover_width": 180,
            "isOrder": 0,    
            "isNoBackground": 0, 
            "label_size": 30,
            "icon_size": 30, 
            "card_label": {
                "letterSpacing": "4px",
                "textTransform": "upperCase", 
                "alignItems": "flex-end",
                "fontWeight": 100
            },
            "card": {
                "borderRight": "5px solid var(--force-plain-color)",
                "background": "linear-gradient(to bottom, rgba(15,168,22,1) 0%,rgba(9,102,26,1) 100%)"
            },
            "card_cover": { "color": "#FFFFFF" },
            "card_icon": { "color": "#FFFFFF" }
        },
        
    ]
}
export default horizontal_accordeon